// Saves a file the page made (an image, a pdf) for the user. In the browser it is a plain download; in the app
// (Capacitor) the web view ignores <a download>, so the file is written to the cache of the app and handed to
// the share sheet of the phone: from there it goes to Photos / Files / Drive or to any app
import { Capacitor } from '@capacitor/core'
import { Filesystem, Directory } from '@capacitor/filesystem'
import { Share } from '@capacitor/share'

export function isNativeApp() {
    return Capacitor.isNativePlatform()
}

// a blob as a data: url
function toDataUrl(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = () => reject(reader.error)
        reader.readAsDataURL(blob)
    })
}

function download(dataUrl, fileName) {
    const link = document.createElement('a')
    link.href = dataUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()
}

// data: a data: url or a Blob / File; title: what the share sheet shows
export async function saveFile(data, fileName, title) {
    const dataUrl = typeof data === 'string' ? data : await toDataUrl(data)
    if (!isNativeApp()) return download(dataUrl, fileName)
    const { uri } = await Filesystem.writeFile({
        path: fileName,
        data: dataUrl.slice(dataUrl.indexOf(',') + 1),
        directory: Directory.Cache
    })
    try {
        await Share.share({ title: title || fileName, files: [uri], dialogTitle: title || fileName })
    } catch (error) {
        // the user closed the share sheet
        if (!/cancel/i.test(String(error && error.message))) throw error
    }
}
